/**
 * @author Iskra Popova
 *
 */

import { IViewConfigSchema, ILayersList, IObjectConfig } from "../baseConfigs/layoutConfigShema";
import SceneView from "../views/SceneView";
import BaseTransition from "../../src/transitions/BaseTransition";
import App from "../App";
import Layout from "./Layout";
import GameEvents from "../../src/const/GameEvents";
import ConsoleUtil from "./ConsoleUtil";

export default class DomLayer  {

    protected activeSceneName: string;
    protected defaultSceneName: string;
    protected activeScene: HTMLImageElement;
    protected transitionScene: HTMLImageElement;
    protected scenes: string[];
    protected domContainer: HTMLElement;
    protected sceneContainer: HTMLElement;
    protected scenesConfig: Map<string, IObjectConfig>;

    constructor(scenes: IObjectConfig[], domContainer: HTMLElement) {
        // super();
        // this.scenes = scenes;
        this.scenesConfig = new Map<string, IObjectConfig>();
        this.scenes = [];
        this.domContainer = domContainer;
        this.sceneContainer = document.createElement('div');
        this.domContainer.appendChild(this.sceneContainer);
        scenes.forEach(scene => {
            const id = scene.id.split("-")[1];
            if (!id) {
                this.defaultSceneName =  scene.id;
            }
            this.scenesConfig.set(scene.id, scene);
            this.scenes.push(scene.id);
        })

        App.dispatcher.on( GameEvents.RESIZE, this.onResize, this);
        // this.layersConfig = layersConfig;
        // this.name = this.defaultSceneName = defaultSceneName;
    }

    public playDefault() {
        if (this.scenes.indexOf(this.defaultSceneName) !== -1) {
            this.setScene();
        }
    }

    public getDefaultSceneName(): string {
        return this.defaultSceneName;
    }

    public getCurrentScene(): HTMLImageElement {
        return this.activeScene;
    }

    public getCurrentTransitionScene(): HTMLImageElement {
        return this.transitionScene;
    }

    public transitionToScene(sceneName: string, transition: BaseTransition, onIn?: (...args: any[]) => void, onComplete?: (...args: any[]) => void  ) {
        if (!sceneName) {
            sceneName = this.defaultSceneName;
        } else if (sceneName !== this.defaultSceneName) {
            sceneName = this.defaultSceneName + "-" + sceneName;
        }


        this.transitionScene = this.createScene(sceneName);
        this.sceneContainer.appendChild(this.transitionScene);
        // const tl = transition.execute();
        // const tl = transition.execute();
        transition.in().then(() => {
            if (onIn) {
                onIn();
            }
            return transition.out();
        }).then( () => {
            this.clear();
            this.activeScene = this.transitionScene;
            // this.addChild(this.transitionScene);
            this.transitionScene = null;
            if (onComplete) {
                onComplete();
            }
        });
    }

    public setScene(sceneName?: string):HTMLImageElement  {
        if (!sceneName) {
            sceneName = this.defaultSceneName;
        } else if (sceneName !== this.defaultSceneName) {
            sceneName = this.defaultSceneName + "-" + sceneName;
        }

        if (this.scenes.indexOf(sceneName) === -1) {
            throw new Error(("No scene found with name " + sceneName + " in layer "));
        }

        if (this.activeSceneName === sceneName && this.activeScene) {
            return this.activeScene;
        } else {
            this.clear();
        }


        this.activeScene = this.createScene(sceneName);
        this.sceneContainer.appendChild(this.activeScene);
        this.positionActiveScene();
        return this.activeScene;
    }

    protected createScene(sceneName: string): HTMLImageElement {
        const img = new Image();
        const texture:any = App.assets.getTexture(sceneName);
        img.src = texture.baseTexture.source; //TODO check if that works
        img.style.position = "relative";
        this.activeSceneName = sceneName;
        return img;
    }

    protected positionActiveScene() {
        if (!this.activeScene) {
            return;
        }
        const sceneConfig = this.scenesConfig.get(this.activeSceneName);
        // const scale = App.instance.stage.scale.x / window.devicePixelRatio;
        const scale = App.instance.stage.scale.x / Layout.globalScale;
        const percentWidth = (sceneConfig.width / App.width) * 100;
        const percentHeight = (sceneConfig.height / App.height) * 100;
        const relWidth = Layout.relWidth(percentWidth);
        const relHeight = Layout.relHeight(percentHeight);
        const canvasWidth = parseInt(App.instance.view.style.width.match(/[0-9]*/)[0]);
        const canvasHeight = parseInt(App.instance.view.style.height.match(/[0-9]*/)[0]);
        const offset = window.innerWidth > canvasWidth ? (canvasWidth-  relWidth * App.instance.stage.scale.x - canvasWidth ) / 2 : 0;
        const offsetY = window.innerHeight > canvasHeight ? (canvasHeight - relHeight * App.instance.stage.scale.y - canvasHeight ) / 2 : 0;
        ConsoleUtil.log(relWidth,offset,offsetY,relHeight,App.instance.stage.scale.x)
        this.activeScene.style.width = relWidth * App.instance.stage.scale.x + "px";
        // console.log(App.instance.stage.width / scale);
        // console.log(App.instance.view.width, canvasWidth);
        this.activeScene.style.left = (offset + (sceneConfig.x  * scale))  + "px";
        this.activeScene.style.top = (offsetY + sceneConfig.y  * scale)   + "px";

        this.sceneContainer.style.width = "100%";
        this.sceneContainer.style.height = "100%";
        this.sceneContainer.style.overflow = "hidden";
        this.sceneContainer.style.position = "absolute";
        this.sceneContainer.style.textAlign = "center";
    }

    protected onResize() {
        if (!this.activeScene) {
            return;
        }
       this.positionActiveScene();

    }

    public clear() {
        if (this.activeScene) {
            this.sceneContainer.removeChild(this.activeScene);
            this.activeScene = null;
        }
        this.activeSceneName = null;
    }


}
